export default __webpack_public_path__ + "cb3d4568f2b1c4712a1c02f448e1ab91.jpg";